// extracted by mini-css-extract-plugin
module.exports = {"buttonCheckBox":"classes_buttonCheckBox__3D0yn","typoResalt":"classes_typoResalt__3TkC6","typoNormal":"classes_typoNormal__3EI3S"};